import { toAmericanDate } from '../../../helpers';
import {
  CORE, RELATORIOS, gateway,
} from '../../api';

export function findUsuariosNegociadores() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-negociador`);
}

export function findRendimentoMensalNegociador(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/rendimento-mensal/negociador/pesquisa`, payload);
}

export function imprimirRendimentoMensalNegociadorExcel(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/negociador/download/excel`, payload);
}

export function imprimirRendimentoMensalNegociadorPdf(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/negociador/download/pdf`, payload);
}

export function findUsuariosComerciais() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-comerciais`);
}

export function findRendimentoMensalComercial(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/rendimento-mensal/comercial/pesquisa`, payload);
}

export function imprimirRendimentoMensalComercialExcel(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/excel`, payload);
}
export function imprimirRendimentoMensalComercialPdf(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/pdf`, payload);
}
